import React from 'react';
import { motion } from 'framer-motion';
import { Phone, PhoneOff } from 'lucide-react';
export function PhoneAnimation() {
  return <div className="relative flex justify-center items-center w-24 h-24 mx-auto mb-6" data-id="element-1">
      {/* Radiating waves */}
      <motion.div className="absolute w-full h-full rounded-full border-2 border-red-500/30" animate={{
      scale: [1, 1.5, 1.8],
      opacity: [0.8, 0.4, 0]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeOut'
    }} data-id="element-2" />
      <motion.div className="absolute w-full h-full rounded-full border-2 border-red-500/20" animate={{
      scale: [1, 1.8, 2.2],
      opacity: [0.6, 0.2, 0]
    }} transition={{
      duration: 1.5,
      repeat: Infinity,
      ease: 'easeOut',
      delay: 0.2
    }} data-id="element-3" />

      {/* Vibrating Phone Icon */}
      <motion.div className="relative z-10 bg-red-600 p-4 rounded-full shadow-[0_0_30px_rgba(220,38,38,0.6)]" animate={{
      x: [0, -3, 3, -3, 3, 0],
      rotate: [0, -2, 2, -2, 2, 0]
    }} transition={{
      duration: 0.4,
      repeat: Infinity,
      repeatDelay: 1.5 // Pause between vibrations
    }} data-id="element-4">
        <Phone className="w-10 h-10 text-white" data-id="element-5" />
      </motion.div>

      {/* "Blocked" overlay that appears periodically */}
      <motion.div className="absolute z-20 top-0 right-0 bg-black rounded-full p-1 border border-[#c9a227]" initial={{
      opacity: 0,
      scale: 0
    }} animate={{
      opacity: [0, 1, 1, 0],
      scale: [0.5, 1.2, 1, 0.5]
    }} transition={{
      duration: 2,
      repeat: Infinity,
      repeatDelay: 1.5,
      times: [0, 0.2, 0.8, 1]
    }} data-id="element-6">
        <PhoneOff className="w-4 h-4 text-[#c9a227]" data-id="element-7" />
      </motion.div>
    </div>;
}